var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    transform: "rotate(90 16 16)",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_1371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0039 17.4975L17.6062 15.9988L15.0039 14.5V17.4975Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8C11.5824 8 8 11.5824 8 16C8 20.4176 11.5824 24 16 24C20.4176 24 24 20.4176 24 16C24 11.5824 20.4176 8 16 8ZM20.9987 16.0082C20.9987 16.0082 20.9987 17.6306 20.793 18.413C20.6776 18.8412 20.34 19.1788 19.9117 19.2941C19.1294 19.5 16 19.5 16 19.5C16 19.5 12.8788 19.5 12.0883 19.2859C11.66 19.1707 11.3224 18.8329 11.207 18.4047C11.0011 17.6306 11.0011 16 11.0011 16C11.0011 16 11.0011 14.3777 11.207 13.5953C11.3223 13.1671 11.6682 12.8212 12.0883 12.7059C12.8706 12.5 16 12.5 16 12.5C16 12.5 19.1294 12.5 19.9117 12.7141C20.34 12.8293 20.6776 13.1671 20.793 13.5953C21.0071 14.3777 20.9988 16.0082 20.9988 16.0082L20.9987 16.0082Z",
    fill: "#1E1E1E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_1371"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterYoutube);
export default __webpack_public_path__ + "static/media/Footer-Youtube.51ac7f380cfff07e5f9e063d7661ff2f.svg";
export { ForwardRef as ReactComponent };